module.exports = __webpack_public_path__ + "static/media/polojenie_konkursa_python.498ec5bf.pdf";